import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, IconButton, Paper } from '@material-ui/core';
import { IconX, IconBell } from '@tabler/icons';
import agentNotificationsService from '../../../../Services/agentNotificationsService';

const AUTO_DISMISS_MS = 5000;

// One toast on screen at a time — if several notifications land in the same
// poll cycle they queue up and play out one after another.
const NotificationToast = () => {
    const [visible, setVisible] = useState(null);
    const queueRef = useRef([]);
    const timerRef = useRef(null);

    const showNext = () => {
        if (queueRef.current.length === 0) {
            setVisible(null);
            return;
        }
        const next = queueRef.current.shift();
        setVisible(next);
        timerRef.current = setTimeout(showNext, AUTO_DISMISS_MS);
    };

    useEffect(() => {
        const unsubscribe = agentNotificationsService.subscribeNew((notification) => {
            queueRef.current.push(notification);
            if (!timerRef.current) showNext();
        });
        return () => {
            unsubscribe();
            if (timerRef.current) clearTimeout(timerRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = null;
        showNext();
    };

    if (!visible) return null;

    return (
        <Box
            style={{
                position: 'fixed',
                top: 76,
                right: 24,
                zIndex: 2000,
                width: 340,
                maxWidth: 'calc(100vw - 32px)',
            }}
        >
            <Paper
                elevation={8}
                style={{
                    borderRadius: 10,
                    padding: '14px 16px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 12,
                    borderLeft: '4px solid #1565c0',
                }}
            >
                <Box style={{ color: '#1565c0', marginTop: 2 }}>
                    <IconBell size="1.3rem" stroke={1.5} />
                </Box>
                <Box style={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                        {visible.title}
                    </Typography>
                    {visible.body ? (
                        <Typography
                            variant="caption"
                            style={{ display: 'block', color: '#6b7280', marginTop: 2, wordBreak: 'break-word' }}
                        >
                            {visible.body}
                        </Typography>
                    ) : null}
                </Box>
                <IconButton size="small" onClick={handleClose} style={{ padding: 4, marginTop: -4, marginRight: -4 }}>
                    <IconX size="1rem" stroke={1.5} />
                </IconButton>
            </Paper>
        </Box>
    );
};

export default NotificationToast;
